import "./Layout.css";

export const Layout = (props) => {
  return (
    <div className={`layout__container grid-${props.grid}`}>
      {props.children}
    </div>
  );
};
